import { Toggle } from '@warp-ds/react/components/toggle';
import type { Filters } from '@/domain';

export type PropertyTypeFilterProps = {
    propertyTypes?: string[];
    onFilterChanged: (filters: Filters) => void;
};

export const propertyTypesList = [
    { name: 'Leilighet', id: '1' },
    { name: 'Hytte/Feriehjem', id: '2' },
    { name: 'Faststående campingvogn', id: '12' },
    { name: 'Båt', id: '4' },
    { name: 'Campinghytte', id: '5' },
    { name: 'Enkeltrom', id: '6' },
    { name: 'Gård', id: '7' },
    { name: 'Hus', id: '8' },
    { name: 'Lavvo', id: '9' },
    { name: 'Rorbu', id: '10' },
    { name: 'Tretopphytte', id: '11' },
];

export const PropertyTypeFilter = ({ propertyTypes = [], onFilterChanged }: PropertyTypeFilterProps) => {
    const handleChange = (checked: boolean, id: string): void => {
        const checkedPropertyTypes = propertyTypes.filter((propertyId) => propertyId !== id);

        if (checked) {
            checkedPropertyTypes.push(id);
        }

        onFilterChanged({ property_types: checkedPropertyTypes });
    };

    return (
        <>
            {propertyTypesList.map(({ name, id }) => (
                <div className="input-toggle" key={id}>
                    <Toggle
                        type="checkbox"
                        label={name}
                        checked={propertyTypes.includes(id)}
                        onChange={(checked: boolean) => handleChange(checked, id)}
                        data-testid={`property_type_${id}`}
                    />
                </div>
            ))}
        </>
    );
};
